import { Component, OnInit } from '@angular/core';
import { HowToTicketsService } from 'src/app/core/services/how-to-tickets/how-to-tickets.service';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PurchaseFlowComponent } from 'src/app/shared/cinejoy/common/purchase-flow/purchase-flow.component';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { StripePurchasePopupComponent } from '../../bulk-purchase/stripe-purchase-popup/stripe-purchase-popup.component';
import { EventType } from '../../passport/models/passport.models';
import { StripePurchaseService } from '../../bulk-purchase/stripe-purchase.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { StripeConfirmationPopupComponent } from '../../bulk-purchase/stripe-purchase-popup/stripe-confirmation-popup/stripe-confirmation-popup.component';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-how-to-tickets',
  templateUrl: './how-to-tickets.component.html',
  styleUrls: ['./how-to-tickets.component.css'],
  providers: [DatePipe]
})
export class HowToTicketsComponent implements OnInit {

  ticketInfo: any;
  timezone: any
  dateRange: string;
  range: string
  endDateRange: any
  pageUrl: string = '';
  isSpotlightSubscriptionActive: boolean = environment.subscription.spotlightSubscriptionActive;
  isShowcaseSubscriptionActive: boolean = environment.subscription.showcaseSubscriptionActive;
  isSubscriptionAllActive: boolean = environment.subscription.subscriptionAllActive;
  isSpotlightSubscribed: boolean = false;
  isAllSubscribed: boolean = false;
  isShowcaseSubscribed: boolean = false;
  isButtonClicked: boolean = false;

  constructor(
    public dialog: MatDialog,
    public service: HowToTicketsService,
    private datePipe: DatePipe,
    private modalService: NgbModal,
    private stripePurchaseService: StripePurchaseService,
    private route: ActivatedRoute,
    public adminService: AdminService,
    private authService: AuthenticationService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.checkForPurchaseCallback();
    this.service.getHowToTicketsInfo().subscribe(data => {
      this.ticketInfo = data;

      const formattedStartDate = this.datePipe.transform(this.ticketInfo.showcaseMovies.startDate, 'MMMM d');
      const formattedEndDate = this.datePipe.transform(this.ticketInfo.showcaseMovies.endDate, 'd, yyyy');
      const formatEndDate = this.datePipe.transform(this.ticketInfo.showcaseMovies.endDate, 'd');

      this.range = `${formattedStartDate}-${formatEndDate}`;

      this.dateRange = `${formattedStartDate}-${formattedEndDate}`;

      const timestampSeconds = this.ticketInfo.showcaseMovies.endDate / 1000;
      const originalDate = new Date(timestampSeconds * 1000);

      const newDate = new Date(originalDate.getTime() + 2 * 24 * 60 * 60 * 1000);
      this.endDateRange = this.datePipe.transform(newDate, 'MMMM d');
      this.spinner.hide();
    });
    this.authService.checkUserAuthenticated().subscribe((res) => {
      if (res.userId > 0) {
        this.getActiveSubscriptions();
      }
    })
  }

  open(premiere: any, purchaseStage: string, purchaseTransactionType: string): void {
    if (!this.isSubscriptionAllActive) {
      const modalRef = this.modalService.open(PurchaseFlowComponent, {
        size: 'lg',
        backdrop: 'static',
      })
      modalRef.componentInstance.premiere = premiere;
      modalRef.componentInstance.purchaseStage = purchaseStage;
      modalRef.result.then(
        (result) => {

        },
        (reason) => {

        },
      );
    }
    else {
      if (this.isButtonClicked) {
        return;
      }
      this.isButtonClicked = true;
      this.populateCallbackUrl();
      this.authService.checkUserAuthenticated().subscribe(
        (res) => {
          if (res.userId === 0) {
            alert("Please login to creatics to purchase tickets.");
            this.isButtonClicked = false;
            location.href = '/login?referer=cinejoy/how-to'
            return;
          }
          else {
            this.openStripPurchasePopup(purchaseTransactionType);
          }
        },
        (err) => {
          location.reload();
          this.isButtonClicked = false;
          console.log(err, 'error while fetching user details (log in detials)----------->');
        }
      );
    }
  }
  private populateCallbackUrl() {
    this.pageUrl = window.location.href;
  }
  openStripPurchasePopup(purchaseTransactionType: string) {
    if ((purchaseTransactionType === 'SUBSCRIPTION_ALL' && (!this.isAllSubscribed && !(this.isShowcaseSubscribed && this.isSpotlightSubscribed))) || (purchaseTransactionType === 'SUBSCRIPTION_SPOTLIGHT' && (!this.isSpotlightSubscribed && !this.isAllSubscribed)) || (purchaseTransactionType === 'SUBSCRIPTION_SHOWCASE' && (!this.isShowcaseSubscribed && !this.isAllSubscribed))) {
      this.dialog.open(StripePurchasePopupComponent, {
        panelClass: 'pre-schedule-modalbox',
        width: '420px',
        height: 'auto',
        data: {
          eventId: "",
          eventType: EventType.SUBSCRIPTION,
          mode: 'purchase',
          url: this.pageUrl,
          puchaseType: 'subscription',
          purchaseTransactionType: purchaseTransactionType,
          availableSubscription: this.isSpotlightSubscribed ? "SPOTLIGHTSUBSCRIBED" : this.isShowcaseSubscribed ? "SHOWCASESUBSCRIBED" : ""
        },
        position: {
          top: '20px'
        }
      }).afterClosed().subscribe((res) => {
        this.isButtonClicked = false;
        console.log('===== dialog closed with response: ', res);
      })
    }
    else {
      this.openInformationPopup('subscribed', {
        'allAccessPass': (this.isAllSubscribed || (this.isShowcaseSubscribed && this.isSpotlightSubscribed)) && purchaseTransactionType === 'SUBSCRIPTION_ALL',
        'spotlightAccessPass': this.isSpotlightSubscribed && purchaseTransactionType === 'SUBSCRIPTION_SPOTLIGHT',
        'showcaseAccessPass': this.isShowcaseSubscribed && purchaseTransactionType === 'SUBSCRIPTION_SHOWCASE'
      })
    }
  }
  checkForPurchaseCallback() {
    this.spinner.hide();
    this.route.queryParams.subscribe(queryParams => {
      if (queryParams.session_id) {

        this.authService.checkUserAuthenticated().subscribe(
          (res) => {
            if (res.userId === 0) {
              alert('Session expired, Please login back to proceed further');
              location.href = '/login?referer=cinejoy/how-to&session_id=' + queryParams.session_id;
              return;
            }
            else {
              this.openStripPaymentConfirmationPopup(queryParams.session_id);
            }
          },
          (err) => {
            location.reload();
            console.log(err);
          }
        );

      }
    }
    )
  }

  openStripPaymentConfirmationPopup(sessionId) {
    this.dialog.open(StripePurchasePopupComponent, {
      panelClass: 'pre-schedule-modalbox',
      width: '600px',
      minHeight: 'auto',
      maxHeight: '75%',
      data: {
        eventId: '',
        eventType: 'SPOTLIGHT',
        mode: 'callback',
        puchaseType: 'subscription',
        purchaseTransactionType: 'SUBSCRIPTION', // sending this to manage UI changes 
        sessionId: sessionId
      }
    }).afterClosed().subscribe((res) => {
      this.getActiveSubscriptions();
      this.populateCallbackUrl();
      console.log('===== dialog closed with response: ', res);
    }
    )
  }
  getActiveSubscriptions() {
    this.adminService.getActiveSubscription().subscribe(
      {
        next: (data: any[]) => {
          console.log("data in Admin service", data);
          data?.map(
            (item) => {
              if (item.purchaseTransactionType === 'SUBSCRIPTION_ALL') {
                this.isAllSubscribed = true;
              }
              else if (item.purchaseTransactionType === 'SUBSCRIPTION_SPOTLIGHT') {
                console.log("Inside condition---->");
                this.isSpotlightSubscribed = true;
              }
              else if (item.purchaseTransactionType === 'SUBSCRIPTION_SHOWCASE') {
                this.isShowcaseSubscribed = true;
              }
            }
          )
          console.log(this.isSpotlightSubscribed, "in how to ticket--->")
        },
        error: (error) => {
          this.openInformationPopup('subscriptionError', '');
          console.log("error while fetching subscription", error);
        }

      })
  }
  openInformationPopup(purpose: string, subscription: any): void {
    this.dialog.open(StripeConfirmationPopupComponent, {
      // panelClass: 'pre-schedule-modalbox',
      width: '500px',
      minHeight: '15%',
      maxHeight: '50%',
      position: {
        top: '20px'
      },
      data: {
        invalidUsers: [],
        guestUsers: 0,
        emptyTicketCount: 0,
        ticketPrice: 0,
        purchaseTransactionType: purpose,
        subscription: subscription
      }
    }).afterClosed().subscribe((res) => {
      this.isButtonClicked = false;
      console.log('===== dialog closed with response: ', res);
    })
  }

  initiatePurchase(purchaseTransactionType: string) {
    if (this.isButtonClicked) {
      return;
    }
    this.isButtonClicked = true;
    this.populateCallbackUrl();
    this.authService.checkUserAuthenticated().subscribe(
      (res) => {
        if (res.userId === 0) {
          alert("Please login to creatics to purchase tickets.");
          this.isButtonClicked = false;
          location.href = '/login?referer=cinejoy/how-to'
          return;
        }
        else {
          // this.openBulkPurchaseDialog(eventId);
          this.openStripPurchasePopup(purchaseTransactionType);
        }
      },
      (err) => {
        location.reload();
        this.isButtonClicked = false;
        console.log(err, 'error while fetching user details (log in detials)----------->');
      }
    );
  }

  navigateToAllAccessPass() {
    this.router.navigate(['cinejoy/all-access-pass'])
  }
}
